import { sn_url } from '../utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'

const umpMiddle = () => next => action => {
    switch (action.type) {
        case 'GET_UMP_NONCE': {
            const xhr = new XMLHttpRequest()
            let status
            let data = null

            xhr.open('GET', `${sn_url}/wp-json/snapi/v0.1/lt-ump-nonce/`)
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    status = xhr.status
                    try {
                        data = JSON.parse(xhr.responseText)
                    } catch (e) {
                        handleError(e)
                    }
                    if (status === 200 && data) {
                        // add value to UMP_exports object found in index.html
                        // eslint-disable-next-line
                        UMP['get_entity_info_nonce'] = data
                    }
                }
            }
            xhr.onerror = function(e) {
                handleError(e)
            }
            xhr.send()
            break
        }

        default:
            return next(action)
    }
}

export default umpMiddle
